import React from 'react';
import Base from './Base';

class Hidden extends Base {
  constructor(...args) {
    super(...args);
    this.inputType = 'hidden';
  }

  render() {
    const inputID = this.getInputID();

    return (
      <input
        type={this.inputType}
        id={inputID}
        name={this.getInputName()}
        value={this.state.value ? this.state.value : ''}
        disabled={this.props.disabled}
        readOnly={this.props.readOnly}
      />
    );
  }
}
export default Hidden;



// WEBPACK FOOTER //
// ./src/components/Form/Input/Hidden.js